module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5716_-_Cia_Termal_Beachewear_-_Moda_Feminina.30a26289.jpg";